import type { Practitioner, Reference, Resource } from '@medplum/fhirtypes'
import { SIGNED_BY_SYSTEM, SIGNED_DATE_SYSTEM } from '#src/codeSystems.ts'
import { Extension } from '#src/decorators.ts'
import { ExtendedResource } from '#src/ExtendedResource.ts'

export abstract class Signable<T extends Resource> extends ExtendedResource<T> {
  @Extension({
    url: SIGNED_DATE_SYSTEM,
    kind: 'valueString',
  })
  signedDate?: string

  @Extension({
    url: SIGNED_BY_SYSTEM,
    kind: 'valueReference',
  })
  signedBy?: Reference<Practitioner>

  protected afterSignHook(
    _signedBy: Reference<Practitioner>,
    _signedDate: string
  ): void {
    // Hook for child classes to implement additional signing logic and model-specific state changes
  }

  sign(signedBy: Reference<Practitioner>, signedDate?: string): void {
    const _signedDate = signedDate ?? new Date().toISOString()
    this.signedBy = signedBy
    this.signedDate = _signedDate
    this.afterSignHook(signedBy, _signedDate)
  }

  get isSigned(): boolean {
    return !!this.signedBy
  }
}
